import React from 'react'

import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { SKELETON_ITEMS } from '../../../../constants'
import { Placeholder } from '../../../shared/ReactBootstrap'

const ReactImageCarouselItemSmallSkeleton = () => {
  return (
    <div className='image-carousel-small-item'>
      {/* Image of Slide */}
      <div key='image-container' className='image-container'>
        <div key='image-placeholder' className='image-placeholder skeleton-img-placeholder' />
        <div className='carousel-item-under-image container placard'>
          <div className='carousel-item-text-container'>
            <Placeholder className='heading' xs={7} />
            <Placeholder className='heading-description' xs={11} />
            <div className='bullet-list'>
              {SKELETON_ITEMS.map((bullet: string) => {
                return (
                  <div className='bullet-list-item' key={JSON.stringify(bullet)}>
                    <div className='bullet-icon icon-placeholder' />
                    <Placeholder className='bullet-text' xs={7} />
                  </div>
                )
              })}
            </div>
            <div className='cta-section-container small-device'>
              <Placeholder.Button xs={5} variant={ButtonTypes.PRIMARY} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReactImageCarouselItemSmallSkeleton
